import dynamic from 'next/dynamic';

const ActiveBonusPopoverDynamic = dynamic(
  async () => import('./index').then((m) => m.ActiveBonusPopover),
  {
    ssr: false,
    loading: () => null,
  }
);

export { ActiveBonusPopoverDynamic };
